module.exports = __webpack_public_path__ + "static/favicon-52374d73e056d5a502edcf9310e3d996.ico";